var recommendSelects = document.querySelector('.recommend-select');

// recommendSelects.forEach(function(select){
//     select.addEventListener('change', function(){
//         console.log("herlere-----------------")
//         var selectVariantId = this.value;
//         var hiddenInput = this.closest('.recommend-upsell-wrapper').querySelector('[input="id"]');
//         hiddenInput = selectVariantId;
//         console.log('aa',  hiddenInput);

//         var options = this.options;
//         for (var i = 0; i < options.length; i++) {
//            options[i].removeAttribute('selected');
//         }

//         var selectOption = this.querySelector(`option[value="${selectVariantId}"]`);
//         const variantImageElement = document.querySelector('.variant-image'); 
//         const variantImageSrc = selectOption.dataset.imageSrc;
//         console.log(variantImageSrc, "here----")
//         variantImageElement.src = variantImageSrc;
//         selectOption.setAttribute('selected', 'selected');
//     });
// });

class CartRecommendations extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      new theme.AjaxProduct(this.form);
      this.selects = document.querySelectorAll('.recommend-porduct-variant');
      this.selects.forEach(select=>{
        
      select.addEventListener("change", this.updateImage.bind(this));
      });
      
    }

    updateImage(e){
       e.preventDefault();
      const selectedVariant = e.target.value;
      const select = e.target;
        var variantImages = select.closest('.recommend-product--wrapper').querySelectorAll('.variant--image__item');
        variantImages.forEach(function(image) {
          if(image.querySelector('img').getAttribute('data-value') == selectedVariant ) {
            image.querySelector('img').classList.remove('hidden');
          }else {
            image.querySelector('img').classList.add('hidden');
          }
        });
       
    }
}

customElements.define('cart-recommendations', CartRecommendations);
class CartShippingproduct extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      new theme.AjaxProduct(this.form);
      this.shippingCheck = this.querySelector(".toggle-switch");
      this.checkButton = this.querySelector('[data-add-to-cart]');
      this.status = this.shippingCheck.querySelector('input');
      this.status.addEventListener("change", this.switchCheckBox.bind(this));
    }

    switchCheckBox(e) {
        if (this.status.checked) {
            this.checkButton.click();
        }else {
            document.querySelector('.remove_protect_product .cart-drawer--remove__item').click();
        }
    }
}

customElements.define('cart-shiping', CartShippingproduct);

// (function shopFixedBtn() {

//   const addToCartBtn = document.getElementById('btn-addTOCart');
//   const observer = new IntersectionObserver((entries) => {  
//     entries.forEach(entry => {  
//         if (entry.isIntersecting) {
//           document.querySelector('.fixed-btn__wrapper').style.opacity = '0';
//           document.querySelector('.fixed-btn__wrapper').style.visibility = 'hidden';
//           document.querySelector('.fixed-btn__wrapper--desktop').style.opacity = '0';
//           document.querySelector('.fixed-btn__wrapper--desktop').style.visibility = 'hidden';
//           console.log('Element is in view');  
//         } else {
//           document.querySelector('.fixed-btn__wrapper').style.opacity = '1';
//           document.querySelector('.fixed-btn__wrapper').style.visibility = 'visible';
//           document.querySelector('.fixed-btn__wrapper--desktop').style.opacity = '1';
//           document.querySelector('.fixed-btn__wrapper--desktop').style.visibility = 'visible';
//           console.log('Element is out of view');  
//         }
//     });  
//   }, { threshold: 0 })

//   observer.observe(addToCartBtn);
// })();

(function shopFixedBtn() {  
  const addToCartBtn = document.getElementById('btn-addTOCart'); // Initial Add to Cart button  
  const stickyWrapper = document.querySelector('.fixed-btn__wrapper'); // Sticky button wrapper  
  const stickyWrapperDesktop = document.querySelector('.fixed-btn__wrapper--desktop'); // Sticky desktop button wrapper  

  // Initially hide the sticky buttons  
  hideStickyButtons();  

  const observer = new IntersectionObserver((entries) => {  
    entries.forEach(entry => {  
      if (entry.isIntersecting) {  
        // If the initial button is in view, keep sticky buttons hidden  
        console.log('Initial ATC button is in view; hiding sticky buttons');  
        hideStickyButtons();  
      } else {  
        // If the initial button is out of view, show the sticky buttons  
        console.log('Initial ATC button is out of view; showing sticky buttons');
        if (window.scrollY > addToCartBtn.getBoundingClientRect().bottom) {
          showStickyButtons();
        }  
      }  
    });  
  }, { threshold: 0 });  

  // Start observing the initial button  
  if (addToCartBtn) {  
    observer.observe(addToCartBtn);  
  }  

  // Function to hide the sticky buttons  
  function hideStickyButtons() {  
    stickyWrapper.style.opacity = '0';  
    stickyWrapper.style.visibility = 'hidden';  
    stickyWrapperDesktop.style.opacity = '0';  
    stickyWrapperDesktop.style.visibility = 'hidden';  
  }  

  // Function to show the sticky buttons  
  function showStickyButtons() {  
    stickyWrapper.style.opacity = '1';  
    stickyWrapper.style.visibility = 'visible';  
    stickyWrapperDesktop.style.opacity = '1';  
    stickyWrapperDesktop.style.visibility = 'visible';  
  }  
})();